import loadGoogleMapsApi from 'load-google-maps-api';

export default class PropertiesGoogleMap {

  constructor() {
    this.googleMap;
    this.activeMapIcon;
    this.inactiveMapIcon;
    this.markers = [];
    this.autoZooming = false;
    this.defaultBounds;
  }

  initMapIcon() {
    this.activeMapIcon = {
			url: '/static/images/icon-map.svg?v=1.1',
			size: new google.maps.Size(20, 36),
			scaledSize: new google.maps.Size(20, 36),
		};
    this.inactiveMapIcon = {
			url: '/static/images/icon-map--inactive.svg?v=1.1',
			size: new google.maps.Size(20, 36),
			scaledSize: new google.maps.Size(20, 36),
		};
  }

  initListeners() {
    const app = this;
    google.maps.event.addListener(this.googleMap, 'bounds_changed', function(event) {
      // because we're using auto bounds setting we don't want to zoom too far
      // if the bounds are very small. this allows users to zoom as far as they want
      // but sets a maximum for our autozoom
      if (this.getZoom() > 12 && app.autoZooming == true) {
          this.setZoom(12);
          app.autoZooming = false;
      }
      if (this.getZoom() < 3 && app.autoZooming == true) {
          this.setZoom(3);
          app.autoZooming = false;
      }
      if (!app.defaultBounds) {
        app.defaultBounds = app.googleMap.getBounds();
      }
    });

  }

  initGoogleMap() {
    const app = this;
    return new Promise(function(resolve, reject){
      loadGoogleMapsApi({key: 'AIzaSyB7mch4b3-jZ3vwrCUeNtJ4VfKxoYqe0oc'}).then(function (googleMaps) {
        const geographicalCenter = {
          lat: 39.8283,
          lng: -98.5795
        }
        app.googleMap = new googleMaps.Map(document.querySelector('.map'), {
          center: geographicalCenter,
          zoom: 4
        });

        const bounds = new google.maps.LatLngBounds();
        bounds.extend(geographicalCenter);
        app.googleMap.fitBounds(bounds);

        app.initMapIcon();
        app.initListeners();

        resolve(true);
      }).catch(function (error) {
        console.error(error)
        reject(false);
      });
    });
  }

  deleteMarkers() {
    this.markers.forEach(function(marker) {
      marker.setMap(null);
    });
    this.markers = [];
  }

  updateMarkers(activeProperties, allProperties) {
    this.deleteMarkers();

    allProperties.forEach(function(property){
      property.active = activeProperties.indexOf(property) !== -1
    });

    const app = this;
    let bounds = new google.maps.LatLngBounds();

    if (!activeProperties.length) {
      this.googleMap.fitBounds(this.defaultBounds);
      return this.googleMap.setZoom(4);
    }

    const infowindow = new google.maps.InfoWindow();

    allProperties.forEach(function(property, index){
      if(!(property.latitude && property.longitude)) {
        return;
      }
      const latlng = { lat: property.latitude, lng: property.longitude };

      const icon = property.active ? app.activeMapIcon : app.inactiveMapIcon;

      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(latlng),
        map: app.googleMap,
        title: property.name,
        icon: icon,
        optimized: false
      });

      const infoWindowContent = `
        <a href="${property.entry_url}" style="color: #425260; font-weight: bold;">${property.name}</a><br/>
        ${property.city}, ${property.state}
      `

      google.maps.event.addListener(marker, 'click', (function(marker, index) {
  			return function() {
  				infowindow.setContent(infoWindowContent);
  				infowindow.setOptions({maxWidth: 200});
  				infowindow.open(app.googleMap, marker);
  			}
  		}) (marker, index));

      app.markers[property.entry_id] = marker;
      if (property.active) {
        bounds.extend(latlng);
      }

    });
    app.googleMap.panTo(bounds.getCenter());
    app.autoZooming = true;
    app.googleMap.fitBounds(bounds);
  }

}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/properties-app/PropertiesGoogleMap.jsx